import api from '../utils/api';
import DispatchConstants from '../constants/DispatchConstants';

const PaymentActions = {
  getDefaultPaymentMethod(listingAlias) {
    return (dispatch) =>
      dispatch(api.users.properties.payments.defaultPaymentMethod(listingAlias)).then((response) => {
        if (response.success) {
          dispatch({
            type: DispatchConstants.DEFAULT_PAYMENT_SUCCESS,
            payload: { ...response.response },
          });
        } else {
          dispatch({
            type: DispatchConstants.DEFAULT_PAYMENT_FAIL,
            payload: response.error,
          });
        }
        return response;
      });
  },
};

export default PaymentActions;
